import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import icons from '../../../../constants/icons';
import type { LogEntry } from './steamGameImportTypes';

export interface SteamGameImportLogPanelProps {
  logs: LogEntry[];
  onClear: () => void;
}

const SteamGameImportLogPanel = forwardRef<
  HTMLDivElement,
  SteamGameImportLogPanelProps
>(function SteamGameImportLogPanel({ logs, onClear }, ref) {
  const { t } = useTranslation();

  return (
    <div
      className="card glass-panel p-3 d-flex flex-column flex-grow-1 overflow-hidden"
      style={{ minHeight: 0 }}
    >
      <div className="d-flex align-items-center mb-3 flex-shrink-0">
        <FontAwesomeIcon icon={icons.TERMINAL} className="text-blue me-2" />
        <h6 className="mb-0 text-uppercase small">{t('System Log')}</h6>
        <button
          type="button"
          className="btn btn-sm btn-link text-secondary ms-auto p-0"
          onClick={onClear}
        >
          {t('Clear')}
        </button>
      </div>

      <div className="activity-log overflow-auto flex-grow-1" ref={ref}>
        {logs.map((log) => (
          <div
            key={log.id}
            className={`log-entry ${log.type === 'success' ? 'text-success' : log.type === 'warning' ? 'text-warning' : 'text-secondary-emphasis'}`}
          >
            <span className="text-secondary opacity-50 me-2">
              [{log.timestamp}]
            </span>
            {log.message}
          </div>
        ))}
        {logs.length === 0 && (
          <div className="text-center py-4 text-secondary opacity-50 small">
            {t('System idle...')}
          </div>
        )}
      </div>
    </div>
  );
});

export default SteamGameImportLogPanel;
